export const ALLOWED_AZURE_GROUPS = [
    'aaca9ca5-d5be-412f-8929-3f232b12185b',
    '8ef55794-cfc0-431b-9410-b19ca181ad6d',
    'c33d28cd-428d-4de1-9d8b-5164962799e0',
    'b8e7b092-6c70-4139-b298-a402ec1ed201',
    // this one is NSP SP AWS_NS_IPA_DevOps
    '8e6f20bb-0eca-44d7-9c9d-eea486e0fb28'
];